module.exports = __webpack_public_path__ + "static/media/pageMainPhoto.5d8d68d3.png";